<script lang="tsx">
  import { defineAsyncComponent } from "vue";
  import CentreDirectoryEntrySkeleton from "./CentreDirectoryEntrySkeleton.vue";
  const CentreDirectoryEntry = defineAsyncComponent(async () => await import("./CentreDirectoryEntry.vue"));


  export default {
    components: { CentreDirectoryEntrySkeleton, CentreDirectoryEntry },
    props: CentreDirectoryEntry.props as (typeof CentreDirectoryEntry["props"]),
  };
</script>

<template>
  <Suspense v-bind.attr="$attrs">
    <CentreDirectoryEntry v-bind.attr="$attrs" v-bind.prop="$props as any"><slot></slot></CentreDirectoryEntry>

    <template #fallback>
      <CentreDirectoryEntrySkeleton v-bind.attr="$attrs" v-bind.prop="$props as any"/>
    </template>
  </Suspense>
</template>
